(function(){
function ready(fn){
if (document.readyState !== 'loading') fn();
else document.addEventListener('DOMContentLoaded', fn);
}
function setupKeepAsShownClean(){
var keepCard = document.getElementById('dlKeepCard');
var designWrap = document.getElementById('dlDesignWrap');
if (!keepCard || !designWrap) { setTimeout(setupKeepAsShownClean, 250); return; }
if (designWrap._dlKeepBound) return;
designWrap._dlKeepBound = true;
var COLOR_PROP_IDS = ['dlMainProp','dlSecondaryProp','dlAccentProp'];
function stripColorProps(){
for (var i = 0; i < COLOR_PROP_IDS.length; i++) {
var el = document.getElementById(COLOR_PROP_IDS[i]);
if (el) { el.disabled = true; el.value = ''; }
}
}
function syncKeep(){
var active = keepCard.classList.contains('selected');
designWrap.style.display = active ? 'none' : '';
var fields = designWrap.querySelectorAll('input, textarea, select');
for (var i = 0; i < fields.length; i++) {
if (fields[i].id !== 'dlKeepProp') fields[i].disabled = active;
}
if (active) stripColorProps();
var keepProp = document.getElementById('dlKeepProp');
if (keepProp) {
keepProp.disabled = false;
keepProp.value = active ? 'Yes' : 'No';
}
}
syncKeep();
document.body.addEventListener('click', function(e){
if (e.target.closest && e.target.closest('#dlKeepCard')) {
setTimeout(syncKeep, 60);
}
});
var form = document.getElementById('dlForm');
if (form) {
form.addEventListener('submit', function(){
var active = keepCard.classList.contains('selected');
var keepProp = document.getElementById('dlKeepProp');
if (keepProp) {
keepProp.disabled = false;
keepProp.value = active ? 'Yes' : 'No';
}
if (active) stripColorProps();
}, true);
}
}
ready(setupKeepAsShownClean);
function setupBikeRequired(){
var form = document.getElementById('dlForm');
var year = document.getElementById('dlYear');
var make = document.getElementById('dlMake');
var model = document.getElementById('dlModel');
if (!form || !year || !make || !model) { setTimeout(setupBikeRequired, 250); return; }
if (form._dlBikeReqBound) return;
form._dlBikeReqBound = true;
try {
year.setAttribute('required', 'required');
make.setAttribute('required', 'required');
model.setAttribute('required', 'required');
} catch(_) {}
try {
var section = year.closest && year.closest('.section');
var title = section && section.querySelector('.section-title');
if (title && !title.querySelector('.dl-required-injected')) {
var badge = document.createElement('span');
badge.className = 'required-tag dl-required-injected';
badge.textContent = 'Required';
badge.style.cssText = 'display:inline-block;margin-left:10px;padding:2px 9px;background:#d11919;color:#fff;border-radius:4px;font-size:11px;font-weight:700;letter-spacing:.5px;vertical-align:middle;text-transform:uppercase;';
title.appendChild(badge);
}
} catch(_) {}
function showBikeError(missing){
var existing = document.getElementById('dlBikeRequiredErr');
if (existing) existing.remove();
var anchor = (missing && missing[0]) || year;
var err = document.createElement('div');
err.id = 'dlBikeRequiredErr';
err.style.cssText = 'background:#fef2f2;border:1px solid #fca5a5;color:#991b1b;padding:10px 14px;border-radius:6px;margin-top:10px;font-size:13.5px;font-weight:600;';
var labels = missing.map(function(el){
if (el === year) return 'Year';
if (el === make) return 'Make';
if (el === model) return 'Model';
return '';
}).filter(Boolean);
err.innerHTML = '⚠️ Please fill in <strong>' + labels.join(', ') + '</strong> before adding to cart — we need to know which bike to cut your graphics for.';
anchor.parentNode.parentNode.appendChild(err);
for (var i = 0; i < missing.length; i++) {
missing[i].style.outline = '2px solid #d11919';
missing[i].style.outlineOffset = '2px';
missing[i].style.borderRadius = '4px';
}
anchor.scrollIntoView({ behavior: 'smooth', block: 'center' });
try { anchor.focus(); } catch(_) {}
}
function clearBikeError(){
var existing = document.getElementById('dlBikeRequiredErr');
if (existing) existing.remove();
[year, make, model].forEach(function(el){
el.style.outline = '';
el.style.outlineOffset = '';
});
}
form.addEventListener('submit', function(e){
var missing = [];
if (!(year.value || '').trim()) missing.push(year);
if (!(make.value || '').trim()) missing.push(make);
if (!(model.value || '').trim()) missing.push(model);
if (missing.length) {
e.stopImmediatePropagation();
e.preventDefault();
showBikeError(missing);
return false;
}
clearBikeError();
}, true);
[year, make, model].forEach(function(el){
el.addEventListener('change', function(){
if ((year.value || '').trim() && (make.value || '').trim() && (model.value || '').trim()) {
clearBikeError();
}
});
el.addEventListener('input', function(){
if ((year.value || '').trim() && (make.value || '').trim() && (model.value || '').trim()) {
clearBikeError();
}
});
});
}
ready(setupBikeRequired);
function setupChangeColors(){
var checkbox = document.getElementById('dlChangeColors');
var mainProp = document.getElementById('dlMainProp');
var secondaryProp = document.getElementById('dlSecondaryProp');
var accentProp = document.getElementById('dlAccentProp');
if (!checkbox) { setTimeout(setupChangeColors, 250); return; }
if (checkbox._dlBoundCC) return;
checkbox._dlBoundCC = true;
if (mainProp) mainProp.value = '';
if (secondaryProp) secondaryProp.value = '';
if (accentProp) accentProp.value = '';
['dlNameMain','dlNameSecondary','dlNameAccent'].forEach(function(id){
var el = document.getElementById(id);
if (el) el.textContent = '—';
});
['dlPickMain','dlPickSecondary','dlPickAccent'].forEach(function(id){
var el = document.getElementById(id);
if (el) { el.style.background = '#f3f4f6'; el.style.border = '1px solid #d1d5db'; }
});
function sync(){
var on = checkbox.checked;
if (mainProp) mainProp.disabled = !on;
if (secondaryProp) secondaryProp.disabled = !on;
if (accentProp) accentProp.disabled = !on;
}
checkbox.addEventListener('change', sync);
sync();
var form = document.getElementById('dlForm');
if (form) {
form.addEventListener('submit', function(){
if (!checkbox.checked) {
if (mainProp) { mainProp.disabled = true; mainProp.value = ''; }
if (secondaryProp) { secondaryProp.disabled = true; secondaryProp.value = ''; }
if (accentProp) { accentProp.disabled = true; accentProp.value = ''; }
}
}, true);
}
}
ready(setupChangeColors);
})();
